// The specs feature: one list for every kind (a navigation entry per kind of the Build and
// Resources groups), the spec page, and the palette's spec search.
import { registerCommandProvider } from "../../app/registry/commands";
import { registerShellMount } from "../../app/registry/mounts";
import { registerNav } from "../../app/registry/nav";
import { kindsIn } from "../../kinds";
import { routes } from "../context";
import { SpecsIndex, specsProvider } from "./palette";

for (const presenter of [...kindsIn("build"), ...kindsIn("resources")]) {
  registerNav({
    id: `specs:${presenter.slug}`,
    group: presenter.group === "resources" ? "resources" : "build",
    labelKey: presenter.pluralKey,
    icon: presenter.icon,
    to: ({ params }) =>
      params.workspace ? routes.specs(params.workspace, { kind: presenter.slug }) : null,
    order: presenter.order,
  });
}
registerShellMount({ id: "specs:index", component: SpecsIndex });
registerCommandProvider(specsProvider);
